/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.insights.rpc.UserInsightsChirpService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery } from 'data-fetching-client/next';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import * as References from './UserInsightsChirpService';
const chirpClient = createRpcClientV2({
  hubHttpClient: noAuthHttp
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.insights.rpc.UserInsightsChirpService#getUserInsights
 */
export const GET_USER_INSIGHTS_QUERY_FIELD_NAME = 'com_hubspot_marketplace_insights_rpc_UserInsightsChirpService_getUserInsights';
export const GET_USER_INSIGHTS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_USER_INSIGHTS_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getUserInsightsRpc, {
      timeout: ctx.timeout,
      request: {}
    });
  }
});